import { FC, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { Media, MediaBody, MediaLeft } from "@ht/components";
import getInitials from "../../../utils/getInitials";
import { activeChatAgentRoom } from "../../../app/chatAgent/chatAgentSlice";
import { IActiveRoom, IStatus } from "../../../app/chatAgent/types";
import * as chatActions from "../../../app/chatAgent/chatAgentSlice";
import CloseIcon from '@ht/shared/fonts/deos-pis/close'

interface IProps {
    name: string;
    status: string;
    closeModal: () => void;
}

const FloatingChatHeader: FC<IProps> = ({ name, status, closeModal }) => {
    const { layoutType, activeRoom, status: chatAgentCallback } = useAppSelector((state) => state.chatagent);
    const { user } = useAppSelector((state) => state.auth);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const backButtonHandler = () => {
        localStorage.removeItem('activeChatRoom');
        if (layoutType == "PAGE") navigate("/chat");
        dispatch(activeChatAgentRoom({} as IActiveRoom));
    };

    const [isTyping, setIsTyping] = useState(false);
    useEffect(() => {
        if (chatAgentCallback.status == "TYPING" && chatAgentCallback.userName != user?.username) {
            setIsTyping(true);
            const timeout = setTimeout(() => {
                setIsTyping(false);
                dispatch(chatActions.chatAgentCallBack({} as IStatus));
            }, 500);
            return () => clearTimeout(timeout);
        } else if (chatAgentCallback.status == "SENT"
            && activeRoom.roomId == chatAgentCallback.roomId) {
            setIsTyping(false);
        }
    }, [activeRoom, chatAgentCallback]);

    return (
        <div className="message-header bg-white px-5 py-3 h-[52px] flex items-center border-b border-gray-100">
            <button
                type="button"
                className="mr-3.8 text-3xl text-primary lg:hidden"
                onClick={backButtonHandler}
            >
                <i className="fa fa-angle-left"></i>
            </button>
            <Media className="items-center">
                <MediaLeft className="w-9 min-w-9">
                    <div className="bg-gray-200 rounded-full w-9 h-9 flex items-center justify-center text-base font-medium">
                        <span>
                            {getInitials(name)}
                        </span>
                    </div>
                </MediaLeft>
                <MediaBody className="ml-3.8 xxsToXs:max-w-[120px] xsToSm:max-w-[250px] sm:max-w-[450px] md:max-w-[650px] lg:max-w-[700px]">
                    <div className="text-md text-gray-700 font-semibold truncate" title={name}>{name}</div>
                    <div>{isTyping ? "typing.." : status}</div>
                </MediaBody>
            </Media>
            <div className="grid w-full">

                <div className="justify-self-end">
                    <CloseIcon
                        onClick={closeModal}
                        className="hover:cursor-pointer text-gray-400 w-4" />
                </div>
            </div>

        </div>
    );
};

export default FloatingChatHeader;
